import { defineMessages } from 'react-intl.macro';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useMessage } from '@tmapy/intl';

import { Link } from '../link';
import { useAuth, useSelector } from '../hooks';
import { Menu } from '../app/components/Menu';
import { FilterLink } from './FilterLink';

const msg = defineMessages({
  title: {
    id: 'prejimka.title',
    defaultMessage: 'Přejímka',
  },
  subtitle: {
    id: 'prejimka.subtitle',
    defaultMessage: ' ',
  },
  prejimky: {
    id: 'prejimka.menu.prejimky',
    defaultMessage: 'Přejímky',
  },
  users: {
    id: 'prejimka.menu.users',
    defaultMessage: 'Uživatelé',
  },
  organizations: {
    id: 'prejimka.menu.organizations',
    defaultMessage: 'Organizace',
  },
});

export const PrejimkaMenu: React.FC = () => {
  const auth = useAuth();
  const formatMessage = useMessage();
  const { homeLink } = useSelector((state) => state.app.config);
  const config = useSelector((state) => state.app.config.prejimka);

  return (
    <Menu
      title={formatMessage(msg.title)}
      subtitle={formatMessage(msg.subtitle)}
      appLink='prejimkaHome'
      homeLink={homeLink}
      userDocumentation={config?.userDocumentation}
    >
      <ul className='sg-u-vs-4'>
        {(!config?.hideDocsCheck || !config?.hideDocsAcceptance) && (
          <li>
            <p className='sg-u-type-sideNavHeading-inverse'>
              <FormattedMessage {...msg.prejimky} />
            </p>
            <ul className='sg-a-mt-1 sg-u-vs-1'>
              {!config?.hideDocsCheck && (
                <li>
                  <FilterLink id='prejimkaNewCheck' to='prejimkaNewCheck' />
                </li>
              )}
              {!config?.hideDocsCheck && (
                <li>
                  <FilterLink id='prejimkaCheckList' to='prejimkaCheckList' />
                </li>
              )}
              {!config?.hideDocsAcceptance && (
                <li>
                  <FilterLink id='prejimkaDocNew' to='prejimkaDocNew' />
                </li>
              )}
              {!config?.hideDocsAcceptance && (
                <li>
                  <FilterLink id='prejimkaDocList' to='prejimkaDocList' />
                </li>
              )}
            </ul>
          </li>
        )}
        {auth.hasPermission('Users', 'list.view', null) && !config?.hideUsers && (
          <li>
            <p className='sg-u-type-sideNavHeading-inverse'>
              <FormattedMessage {...msg.users} />
            </p>
            <ul className='sg-a-mt-1 sg-u-vs-1'>
              <li>
                <FilterLink id='prejimkaUserList' to='prejimkaUserList' />
              </li>
            </ul>
          </li>
        )}
        {auth.hasPermission('Organizations', 'list.view', null) && !config?.hideOrganizations && (
          <li>
            <p className='sg-u-type-sideNavHeading-inverse'>
              <FormattedMessage {...msg.organizations} />
            </p>
            <ul className='sg-a-mt-1 sg-u-vs-1'>
              {auth.hasPermission('Organizations', 'create.view', null) && (
                <li>
                  <FilterLink id='prejimkaNewOrganization' to='prejimkaNewOrganization' />
                </li>
              )}
              <li>
                <FilterLink id='prejimkaOrganizationList' to='prejimkaOrganizationList' />
              </li>
            </ul>
          </li>
        )}
      </ul>
    </Menu>
  );
};
